import ShowCard from '../../components/ShowCard/ShowCard';
import { TableContext } from '../../contexts/tableContext';
import styles from './index.module.scss';
import React, { useContext, useEffect } from 'react';

const ShowsIndex = React.memo(() => {
  const { dashboardStyle, bodyStyle, setDashboardHeader } = useContext(TableContext);
  useEffect(() => {
    setDashboardHeader('');
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className={styles[bodyStyle]}>
      <div className={styles[dashboardStyle]} id={styles.dashboardcont2}>
        <ShowCard />
      </div>
    </div>
  );
});
export default ShowsIndex;
